import { useI18nContext } from "@i18n/i18n-react";
import { createFileRoute } from "@tanstack/react-router";
import { AppHeader } from "~/components/layout/AppHeader";
import { PageContainer } from "~/components/layout/PageContainer";

export const Route = createFileRoute("/profile/locations")({
	beforeLoad: () => {
		document.title = 'bacehub | Startseite'
	},
	component: RouteComponent,
});

export default function RouteComponent() {
	const i18n = useI18nContext().LL["new-ui"];

	return (
		<PageContainer>
			<AppHeader service="ALL" />
			<h1 className="text-2xl font-breit px-6 py-4">Locations</h1>
			<div className="px-6">
				<div>Location settings will be implemented here</div>
			</div>
		</PageContainer>
	);
}
